import { render, staticRenderFns } from "./DeliveryCompanyDialog.vue?vue&type=template&id=13b7951d"
import script from "./DeliveryCompanyDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryCompanyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports